<template>
    <vue-editor
        id="editor-mention"
        v-model="content"
        ref="editor"
        :editorOptions="editorSettings"
        @input="handleInput"
    ></vue-editor>    
</template>

<script>
	export default {
		name: 'editor-mention',
			
		props: {
			value: String,
		},

		data() {
			return {
				content: this.value,
				atValues:  this.$store.getters.usersSeq,
				editorSettings: {
					placeholder: 'Inserisci un commento..',
					modules: {
						toolbar: false,
						mention: {
							listItemClass: 'ql-mention-list-item-custom background-1',
							allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
							mentionDenotationChars: ['@'],
							source: (searchTerm, renderList, mentionChar) => {
								let values

								if (mentionChar === '@') {
									values = this.atValues
								}

								if (searchTerm.length === 0) {
									renderList(values, searchTerm)
								} else {
									const matches = []
									for (let i = 0; i < values.length; i++)
										if (~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) matches.push(values[i])
									renderList(matches, searchTerm)
								}
							},
							renderItem: (item) => {
								const user = this.$store.getters.users[item.id]
								const avatar = user && user.avatar
								if (avatar) {
									return `<div class="mention-item"><span class="mention-avatar" style="background-image: url(${avatar})"></span><span>${item.value}</span></div>`
								}
								return `<div class="mention-item"><span class="mention-avatar-initial">${item.value.charAt(0)}</span><span>${item.value}</span></div>`
							},
						},
					}
				},
			}
		},

		methods: {
			handleInput (e) {
				this.$emit('input', this.content)
			},

			// Inserisce la menzione in fondo al testo (es. "Rispondi" su un commento).
			// Sorgente 'api' per non far riaprire a quill-mention la tendina dei suggerimenti
			insertMention(user) {
				const quill = this.$refs.editor.quill

				if (!this.content || !this.content.includes(`data-id="${user.id}"`)) {
					let index = quill.getLength() - 1
					if (index > 0 && !/\s/.test(quill.getText(index - 1, 1))) {
						quill.insertText(index, ' ', 'api')
						index++
					}
					quill.insertEmbed(index, 'mention', { denotationChar: '@', id: user.id, value: user.value }, 'api')
					quill.insertText(index + 1, ' ', 'api')
				}

				quill.focus()
				quill.setSelection(quill.getLength() - 1, 0, 'api')
			}
		},

		mounted() {
			this.$eventBusUtility.$on('inputEmpty', () => {
				this.content = ''
			})
		},
		
		beforeDestroy() {
			this.$eventBusUtility.$off('inputEmpty')
		},
	}
	
</script>

<style>
    #editor-mention {
        border: none !important;
    }

    #editor-mention .ql-editor {
        border: 1px solid #A3A3A3;
        border-radius: 6px;
        min-height: 45px !important;
        max-height: 150px;
        overflow-y: auto;
    }

    .ql-editor-disabled {
      border-radius: 6px;
      background-color: rgba(124, 0, 0, 0.2);
      transition-duration: 0.5s;
    }

    #editor-mention .ql-editor:focus {
    }

    .ql-mention-list {
		padding-left: 0px !important;
	}

    .ql-mention-list-container {
		max-height: 300px;
		overflow: auto;
		border: none !important;
		border-radius: 8px;
		box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
		background: var(--v-background-2-base, #ffffff);
		padding: 4px 0;
    }

    /* Styling for action button example */

    .cql-list-item {
      cursor: pointer;
      color: #7c0000;
      background-color: white;
    }

    .cql-list-item.selected {
      color: white;
      background-color: #7c0000;
    }

    .cql-list-item-inner {
      padding: 12px;
      transition-duration: 0.6s;
    }

    .cql-list-item-inner:hover {
      padding-left: 20px;
      color: white;
      background-color: #7c0000;
      transition-duration: 0.3s;
    }

    .cql-list-item .cql-list-item-action {
      cursor: pointer;
      padding: 12px;
      color: white;
      background-color: #7c0000;
      border-top: 4px dashed white;
      transition-duration: 0.6s;
    }

    .cql-list-item.selected .cql-list-item-action {
      padding-left: 20px;
      transition-duration: 0.3s;
    }

    /* MENTION STYLE */

    .ql-mention-list-item-custom {
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        padding: 0px 20px;
        vertical-align: middle;
        font-weight: 400;
        transition: background-color 0.15s ease;
    }

    .mention-item {
        display: flex;
        align-items: center;
    }

    .mention-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        background-size: cover;
        background-position: center;
        flex-shrink: 0;
    }

    .mention-avatar-initial {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        background-color: var(--primary-color);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        flex-shrink: 0;
    }

    .ql-mention-list-item-custom {
        position: relative;
    }

    .ql-mention-list-item-custom:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }

    .ql-mention-list-item-custom.selected {
        font-weight: 500;
        text-decoration: none;
    }

    .ql-mention-list-item-custom.selected::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--primary-color);
        opacity: 0.12;
        pointer-events: none;
    }

    .ql-container {
        font-family: 'Roboto', sans-serif !important;
    }

    .mention {
        height: 24px;
        width: 65px;
        border-radius: 28px !important;
        background-color: #e0e0e0 !important;
        padding: 3px 0px;
        font-size: 13px;
        margin: 4px;
    }

    .mention > span {
        cursor: default;
        height: 32px;
        justify-content: space-between;
        padding: 0 11px;
        white-space: nowrap;
        z-index: 1;
        margin: 0 !important;      
    }
</style>
